import { Util } from "/global/js/util.min.js?v=1793404433";
const util = new Util();
util.bootstrapWasValidated();
util.addAsteriskRequiredFieldsLabel();
util.initCopyToClipboard();
const wrapper = document.querySelector(".is-wrapper");
const footerElement = document.querySelector("footer");
const topMenuLayers = document.querySelectorAll("nav.topHeader, nav.top, nav.topSub");
let stickyTopMenuOffsetRafId = 0;
let announcementTopbarResizeObserver = null;
function calculateWrapper() {
  if (!(wrapper instanceof HTMLElement)) {
    return;
  }
  const windowHeight = window.innerHeight;
  const topMenuHeight = getTopMenuHeight();
  const footerOffsetHeight = footerElement instanceof HTMLElement ? footerElement.offsetHeight : 0;
  const minHeight = windowHeight - topMenuHeight - footerOffsetHeight;
  wrapper.style.minHeight = minHeight + 'px';
}
function adjustScrollPaddingTop() {
  document.documentElement.style.scrollPaddingTop = getTopMenuHeight() + 'px';
}
function isStickyTopMenuLayer(elm) {
  if (!(elm instanceof HTMLElement)) {
    return false;
  }
  return window.getComputedStyle(elm).position === "sticky";
}
function hasStickyTopMenuLayer() {
  for (const elm of topMenuLayers) {
    if (isStickyTopMenuLayer(elm)) {
      return true;
    }
  }
  return false;
}
function getTopMenuHeight() {
  let height = 0;
  topMenuLayers.forEach(elm => {
    if (isStickyTopMenuLayer(elm)) {
      height += elm.offsetHeight;
    }
  });
  return height;
}
function getSystemAnnouncementsTopbarOffset() {
  if (window.systemAnnouncementsTopbar && typeof window.systemAnnouncementsTopbar.getTopbarOffset === "function") {
    return window.systemAnnouncementsTopbar.getTopbarOffset();
  }
  const topbar = document.getElementById("systemAnnouncementsTopbar");
  return topbar ? Math.max(0, Math.ceil(topbar.getBoundingClientRect().height)) : 0;
}
function updateStickyTopMenuOffsets() {
  const announcementOffset = getSystemAnnouncementsTopbarOffset();
  const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
  const visibleAnnouncementOffset = Math.max(announcementOffset - scrollTop, 0);
  let stickyLayerOffset = visibleAnnouncementOffset;
  topMenuLayers.forEach(elm => {
    const isSticky = isStickyTopMenuLayer(elm);
    if (!isSticky) {
      elm.style.removeProperty("top");
      return;
    }
    elm.style.setProperty("top", `${stickyLayerOffset}px`, "important");
    stickyLayerOffset += elm.offsetHeight;
  });
}
function scheduleStickyTopMenuOffsetUpdate() {
  if (stickyTopMenuOffsetRafId) {
    return;
  }
  stickyTopMenuOffsetRafId = window.requestAnimationFrame(() => {
    stickyTopMenuOffsetRafId = 0;
    updateStickyTopMenuOffsets();
  });
}
function initStickyTopMenuOffsets() {
  if (!hasStickyTopMenuLayer()) {
    return;
  }
  updateStickyTopMenuOffsets();
  window.addEventListener('scroll', scheduleStickyTopMenuOffsetUpdate, {
    passive: true
  });
  window.addEventListener('resize', updateStickyTopMenuOffsets);
  window.addEventListener('load', updateStickyTopMenuOffsets);
  const topbar = document.getElementById("systemAnnouncementsTopbar");
  if (topbar && window.ResizeObserver) {
    announcementTopbarResizeObserver = new ResizeObserver(() => scheduleStickyTopMenuOffsetUpdate());
    announcementTopbarResizeObserver.observe(topbar);
  }
}
if (wrapper) {
  calculateWrapper();
  window.addEventListener('resize', () => calculateWrapper());
}
adjustScrollPaddingTop();
window.addEventListener('resize', () => adjustScrollPaddingTop());
initStickyTopMenuOffsets();
document.querySelectorAll('a[target="_blank"]').forEach(link => {
  const linkText = link.textContent.trim();
  if (!link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', linkText + ' (åbner i nyt vindue/fane)');
  }
  const fields = document.querySelectorAll('input[required], textarea[required], select[required]');
  fields.forEach(field => field.setAttribute('aria-required', 'true'));
});

// Nedenstående script sørger for at skip-to-content kunne kommer frem ved egentlig tab
const skip = document.querySelector('#skip-to-content');
let usingKeyboard = false;
window.addEventListener('keydown', e => {
  if (e.key === 'Tab') usingKeyboard = true;
});
window.addEventListener('mousedown', () => {
  usingKeyboard = false;
});
skip.addEventListener('focus', () => {
  if (usingKeyboard) {
    // Kun ved “ægte” tab-fokus: gør det synligt
    skip.classList.add('visible-skip');
  } else {
    // Programmatisk fokus (fx DevTools): fjern fokus med det samme
    skip.blur();
  }
});
skip.addEventListener('blur', () => {
  skip.classList.remove('visible-skip');
});
window.addEventListener('focus', () => {
  if (document.activeElement === skip && !usingKeyboard) {
    skip.blur();
  }
});